import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login"
}
const _hoisted_2 = { class: "login__container" }
const _hoisted_3 = { class: "login__title" }
const _hoisted_4 = { class: "login__text text-capitalize-first" }
const _hoisted_5 = { class: "login__form" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_hcaptcha = _resolveComponent("vue-hcaptcha")!

  return (!_ctx.store.getters.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('login.log_in')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('login.login_to_continue')), 1),
          _createElementVNode("form", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control login__input user-icon",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              placeholder: _ctx.$t('labels.login')
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.username]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control login__input password-icon",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              placeholder: _ctx.$t('labels.password')
            }, null, 8, _hoisted_7), [
              [_vModelText, _ctx.password]
            ]),
            (_ctx.captchaSiteKey)
              ? (_openBlock(), _createBlock(_component_vue_hcaptcha, {
                  key: 0,
                  ref: "captcha",
                  sitekey: _ctx.captchaSiteKey,
                  language: _ctx.lang,
                  onVerify: _ctx.onCaptchaVerify,
                  onExpired: _cache[2] || (_cache[2] = ($event: any) => (_ctx.captchaToken = null)),
                  onChallengeExpired: _cache[3] || (_cache[3] = ($event: any) => (_ctx.captchaToken = null)),
                  onError: _ctx.onCaptchaError
                }, null, 8, ["sitekey", "language", "onVerify", "onError"]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"])),
              class: "btn btn--accept text-capitalize-first w-100",
              disabled: !!_ctx.captchaSiteKey && !_ctx.captchaToken
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('button.enter')), 1)
            ], 8, _hoisted_8)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}